/**
 * @generated SignedSource<<ff4eb4f8f0ea6bb4910e6da84b8dafeb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LessonsSignedOutBanner_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useCurrentClubSlug_session" | "useIsUserSignedIn_session" | "useUserBelongsToCurrentClub_session">;
  readonly " $fragmentType": "LessonsSignedOutBanner_session";
};
export type LessonsSignedOutBanner_session$key = {
  readonly " $data"?: LessonsSignedOutBanner_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"LessonsSignedOutBanner_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LessonsSignedOutBanner_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useIsUserSignedIn_session"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useUserBelongsToCurrentClub_session"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCurrentClubSlug_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "6a13359cb4521da5348287013f51ef48";

export default node;
